var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-page"},[(_vm.showPulse)?_c('section',{staticClass:"panel"},[_c('Pulse')],1):_vm._e(),(_vm.showFace)?_c('section',{staticClass:"panel"},[_c('FaceSimpleView')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }